// ArtworkDetails.js — scheda sintetica nel drawer laterale
import React from 'react';
import ImageDecoder from '../Utils/ImageDecoder/ImageDecoder';
import { hasPicture } from '../Utils/pictures';
import { useLanguage } from '../../LanguageContext';

const ArtworkDetails = ({ currentArtwork }) => {

    const { selectedLanguage } = useLanguage();
    const getLangContent = (content) => content ? content[selectedLanguage === 'it' ? 'it_IT' : 'en_GB'] : '';

    const cover = (currentArtwork.pictures || [])
        .find(picture => picture.is_cover === true && hasPicture(picture));

    // datazione sintetica: testo libero o range numerico della prima data
    const firstDate = (currentArtwork.dates || [])[0];
    const dateLabel = firstDate
        ? (getLangContent(firstDate.date)
           || [firstDate.data_inizio, firstDate.data_fine].filter(Boolean).join(' – '))
        : '';

    const locationLabel = currentArtwork.location
        ? [currentArtwork.location.city_town, currentArtwork.location.name_off].filter(Boolean).join(', ')
        : '';

    return (
        <div className="artworkDetailCard">
            {cover && (
                <div className="detailCover">
                    <ImageDecoder
                        isCover={true}
                        key={cover.id}
                        className='img-fluid'
                        pictureId={cover.id}
                        altText={getLangContent(cover.title)}
                    />
                </div>
            )}

            <h4 className="detailTitle">
                {getLangContent(currentArtwork.name)}
            </h4>

            <dl className="detailFields">
                {locationLabel && (
                    <>
                        <dt>{selectedLanguage === 'it' ? 'Luogo di conservazione' : 'Location'}</dt>
                        <dd>{locationLabel}</dd>
                    </>
                )}
                {dateLabel && (
                    <>
                        <dt>{selectedLanguage === 'it' ? 'Datazione' : 'Dating'}</dt>
                        <dd>{dateLabel}{(currentArtwork.dates || []).length > 1 ? ' …' : ''}</dd>
                    </>
                )}
                {currentArtwork.inventory_number && (
                    <>
                        <dt>{selectedLanguage === 'it' ? 'N° Inventario' : 'Inventory No.'}</dt>
                        <dd>{currentArtwork.inventory_number}</dd>
                    </>
                )}
            </dl>

            <a target='_blank' rel="noreferrer" href={`/artwork/${currentArtwork.id}`} className="detailBtn">
                {selectedLanguage === 'it' ? 'Approfondisci' : 'Read more'} →
            </a>
        </div>
    );
};

export default ArtworkDetails;
